import React from 'react';
import { useLocation } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import AddSupplier from '../../components/supplier_comp/AddSupplier';

/**
 * AddSupplierPage — Page wrapper for Add/Edit Supplier module
 * Title switches between "Add Supplier" and "Edit Supplier"
 * based on whether location.state contains a supplier record.
 */
const AddSupplierPage = () => {
    const { state } = useLocation();

    // Match the same id-based detection used inside AddSupplier component
    const isEditMode = !!(state?.id ?? null);
    const pageTitle = isEditMode ? 'Edit Supplier' : 'Add Supplier';

    return (
        <div className="d-flex flex-column h-100 overflow-hidden py-2 py-md-3 px-0 px-md-5">
            <div className="flex-shrink-0">
                <PageHeader title={pageTitle} />
            </div>
            <div className="flex-grow-1 overflow-auto d-flex flex-column">
                <AddSupplier />
            </div>
        </div>
    );
};

export default AddSupplierPage;